import React, { useEffect, useState, Fragment } from 'react';
import Barcode from '../Barcode/Barcode';
import classes from './OfferDetails.module.scss';
import Button from '../../UI/Button/Button';
import moment from 'moment';
import Loader from '../../UI/Loader/Loader';
import { useSelector } from 'react-redux';
import QrCode from '../../UI/QrCode/QrCode';
import { withCookies, useCookies } from 'react-cookie';

const OfferDetails = (props) => {
    const { hasTimer, hideAt, limitSeconds, content} = props;
    const [barcodeMessage, setBarcodMessage] = useState(false);
    const [showCountdown, setShowCountdown] = useState(false);

    const [days, setDays] = useState('');
    const [hours, setHours] = useState('');
    const [minutes, setMinutes] = useState('');
    const [seconds, setSeconds] = useState('');
    const deviceSelector = useSelector((state) => state.device);
    const deviceLocaleIsFrench = deviceSelector.deviceDetails.locale.search('fr') > -1;

    const [
        cookies,
        setCookie,
        // removeCookie
    ] = useCookies(['A8USERTIER', 'A8USERQRCODE']); 

    useEffect(()=> {
        console.log(content)
        const setZeros = (num, f) => {
            let n = String(num / 100).slice(2);
            return n.length === 0 && f?.length === 2 ? '00' : n.length === 1 ? n + '0' : n;
        }
        setDays(
            setZeros(
                Math.floor(props.distance / (1000 * 60 * 60 * 24)),
                days
            ),
        );
        setHours(
            setZeros(
                Math.floor((props.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                hours
            )
        );
        setMinutes(
            setZeros(
                Math.floor((props.distance % (1000 * 60 * 60)) / (1000 * 60)),
                minutes
            )
        );
        setSeconds(
            setZeros(
                Math.floor((props.distance % (1000 * 60)) / 1000),
                seconds
            )
        );
    }, [days, hours, minutes, props.distance, seconds, content]);

    useEffect(() => {
        if (hasTimer) {
            if (hideAt !== 0 && !props.running) {
                let expDate = moment(hideAt);
                props.onSetExpDate(expDate);
                setBarcodMessage(false);
                setShowCountdown(true);
                props.onSetRunning(true)
            } 
            if (props.running) {
                setBarcodMessage(false);
                setShowCountdown(true);
            } else {
                setShowCountdown(false);
                setBarcodMessage(true);
            }
        }
    }, [hasTimer, hideAt, limitSeconds, props])

    const handleTimerStart = () => {
        const expDate = moment().add(limitSeconds, 'seconds');
        props.onSetExpDate(expDate);
        props.onSetRunning(true);
        props.onUpdateStatus(4)
        setBarcodMessage(false)
        setShowCountdown(true);
    }

    let barcode = (
        <div>
            <div className={classes.OfferDetailsModalTitle} style={{fontFamily: "Inter", fontSize: "14px", fontWeight: "400", lineHeight: "22px"}}>
                <strong>{deviceLocaleIsFrench ? process.env.REACT_APP_OFFER_DETAILS_HOW_TO_REDEEM_TITLE_TEXT_FR : process.env.REACT_APP_OFFER_DETAILS_HOW_TO_REDEEM_TITLE_TEXT_EN}</strong>
                {deviceLocaleIsFrench ? process.env.REACT_APP_OFFER_DETAILS_HOW_TO_REDEEM_SUBTITLE_TEXT_FR : process.env.REACT_APP_OFFER_DETAILS_HOW_TO_REDEEM_SUBTITLE_TEXT_EN}
            </div>
            {
                showCountdown && (
                    <div className={classes.CountDown}>
                        <p className={classes.CountDownText}>This code is available for
                            <span>
                                {days !== '' && days+':'}{hours !== '' && hours+':'}{minutes !== '' && minutes + ':'}{seconds !== '' && seconds}
                            </span>
                        </p>
                    </div>
                )
            }
            <Barcode
                showCountdown={showCountdown}
                showBarcode={hasTimer ? false : true}
                // handleExpire={handleExpire}
                content={content}>
            </Barcode>
            {cookies.A8USERQRCODE ? <div>
                <p style={{fontSize: '14px'}}>Your Red By Dufry <br/>{cookies.A8USERTIER} Member QR Code</p>
                <QrCode value={cookies.A8USERQRCODE}/>
            </div> : <Button btnText={'Tap here to access your Red By Dufry Member QR Code'} 
                        style={{
                            marginLeft: 'auto', 
                            marginRight: 'auto',
                            marginTop: "10px",
                            marginBottom: "20px",
                            height: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_HEIGHT?? "44px",
                            // width: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_WIDTH ?? "200px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontFamily: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_FAMILY,
                            fontWeight: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_FONT_WIGHT,
                            color: 'rgb(105 174 189)',
                            // border: process.env.REACT_APP_REGISTRATION_MODULE_BUTTON_BORDER,
                            background: 'none'
                        }}
                        onClick={() => {                    
                            
                            let ssoUrl = process.env.REACT_APP_REGISTRATION_MODULE_SSO_LOGIN_URL;

                            if(!ssoUrl) {
                                return;
                            } else if(cookies.A8REFER) {
                                ssoUrl += '&' + atob(cookies.A8REFER)
                            }
                            
                            // Post Event as well
                            // postEvent(deviceSelector.deviceDetails, {
                            //     category : 'end-user-action',
                            //     subcategory : 'authentication',
                            //     action : 'click-through',                    
                            //     label : 'Register Button | ' + ssoUrl,
                            //     content_id : null,
                            //     client_id : deviceSelector.deviceDetails.client_id,
                            //     campaign_id : null,
                            //     trigger_id : null                    
                            // });

                            window.location.href = ssoUrl;
                        }}/>
            }
            {/* <div className={classes.BarcodeFooter}>
                <div style={{ height: '26px', width: '26px' }}>
                    <img
                        height='100%'
                        width='100%'
                        src={ScanImg}
                        alt='scan icon'
                    />
                </div>
                <div
                    className={classes.BarcodeFooterCopy}
                    style={{ paddingLeft: '10px' }}>
                    <div>Take a screenshot to save</div>
                    <div>this offer for later use.</div>
                </div>
            </div> */}

            {/* <div className={classes.OfferDetailsModalTitle} style={{fontFamily: "Inter", fontSize: "14px", fontWeight: "400", lineHeight: "22px"}}>
            {deviceLocaleIsFrench ? process.env.REACT_APP_OFFER_DETAILS_HOW_TO_REDEEM_FOOTER_TEXT_FR : process.env.REACT_APP_OFFER_DETAILS_HOW_TO_REDEEM_FOOTER_TEXT_EN}
            </div> */}

            <div></div>
            {/* <div style={{
                height: "60px",
                // borderBottom: "10px black",
                // boxShadow: "0 2px 10px 0 rgba(0,0,0,0.5)",
                width : "100%",
                paddingTop: "16px"
            }}> 
            <Button 
                style={{
                    boxSizing: "border-box",
                    height: "44px",
                    width: "100%",
                    border: "2px solid #CB1416",
                    borderRadius: "22px",
                    marginLeft: "auto",
                    marginRight: "auto",
                    color: "#CB1416",
                    fontFamily: "Inter",
                    fontSize: "13px",
                    fontWeight: "600",
                    backgroundColor: "white"
                }}
                btnText={deviceLocaleIsFrench ? process.env.REACT_APP_USER_PROFILE_BUTTON_TEXT_FR : process.env.REACT_APP_USER_PROFILE_BUTTON_TEXT_ENG}
                leftIcon={'qrcode'}
                rightIcon={'arrow'}
                onClick={() => {                    
            
            
                    // Post Event as well
                    // postEvent(deviceSelector.deviceDetails, {
                    //     category : 'end-user-action',
                    //     subcategory : 'authentication',
                    //     action : 'click-through',                    
                    //     label : 'Register Button | ' + ssoUrl,
                    //     content_id : null,
                    //     client_id : deviceSelector.deviceDetails.client_id,
                    //     campaign_id : null,
                    //     trigger_id : null                    
                    // });

                window.open(process.env.REACT_APP_USER_PROFILE_BUTTON_URL, '_blank');
                }}/>
            </div> */}
        </div>
    );

    const modalIcon = (
        <div className={classes.OfferDetailsModalIconContainer}>
            <img
                className={classes.OfferDetailsModalIcon}
                src={content?.images?.thumbnail?.url}
                alt='wallet_icon'
            />
        </div>
    );

    const expMessage = (
        <div>
            <p>This offer has been redeemed or is no longer available. </p>
            <p>Thank you.</p>
        </div>
    )

    return (
        <Fragment>
            {barcodeMessage ? (
                <div style={{maxWidth: '300px'}} className={classes.OfferDetailsModalContainer}>
                    <p className={classes.MessageTitle}>Ready to redeem?</p>
                    <p>This offer may only be used <strong>once</strong> and will be valid for a short time.</p>
                    <p>Please be in-person and ready to show an associate the promo code to redeem this offer.</p>
                    <div>
                        <div style={{width: '260px', margin: '24px 0'}}>
                            <Button
                                backgroundColor={'#DC0000'}
                                onClick={handleTimerStart}
                                btnText={'Show Promo Code'}
                                className={classes.Button}>
                            </Button>
                        </div>
                        <div onClick={props.onClose} className={classes.CloseLink}>
                            Not Ready
                        </div>
                    </div>
                </div>
            ) :
            
            (
                <div
                    id={'copyCodeContainer'}
                    className={classes.OfferDetailsModalContainer}>
                    {modalIcon}
                    {
                        (props.expired === null && hasTimer) ?
                        <Loader style={{margin: '24px'}}/> :
                        props.expired ?
                        expMessage :
                        barcode
                    }
                </div>
            )}
        </Fragment>
    );
};

export default OfferDetails;
